import {
    CREATE_COMPACTING_DC_FAILURE_DK,
    CREATE_COMPACTING_DC_REQUEST_DK,
    CREATE_COMPACTING_DC_SUCCESS_DK,
    CREATE_USER_FORM_COMPACTING_DC_DK,
    FETCH_SINGLE_COMPACTING_DC_FAILURE_DK,
    FETCH_SINGLE_COMPACTING_DC_REQUEST_DK,
    FETCH_SINGLE_COMPACTING_DC_SUCCESS_DK,
    FETCH_COMPACTING_DC_FAILURE_DK,
    FETCH_COMPACTING_DC_REQUEST_DK,
    FETCH_COMPACTING_DC_SUCCESS_DK,
    NAVIGATE_COMPACTING_DC_DETAILS_DK,
    NAVIGATE_COMPACTING_DC_DK,
    COMPACTING_DC_USERFORM_RESET_DK,
    UPDATE_COMPACTING_DC_FAILURE_DK,
    UPDATE_COMPACTING_DC_REQUEST_DK,
    UPDATE_COMPACTING_DC_SUCCESS_DK,
    DELETE_COMPACTING_DC_REQUEST_DK,
    DELETE_COMPACTING_DC_SUCCESS_DK,
    DELETE_COMPACTING_DC_FAILURE_DK,
    COMPACTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK,
    COMPACTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK,
    FETCH_COMPACTING_DC_INVOICE_REQUEST,
    FETCH_COMPACTING_DC_INVOICE_SUCCESS,
    FETCH_COMPACTING_DC_INVOICE_FAILURE,
    RESET_COMPACTING_DC_INVOICE,
    FETCH_COMPACTING_DC_STYLE_REQUEST_DK,
    FETCH_COMPACTING_DC_STYLE_SUCCESS_DK,
    FETCH_COMPACTING_DC_STYLE_FAILURE_DK
} from './compactingDC.actionsType';

export const COMPACTING_DC_DK = 'compactingDCDK';

let initialState = {
    loading: false,
    compactingDC: [],
    compactingDCInvoice: [],
    compactingDCStyleList: [],

    userform: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldIsInHouseDelivery: false,
        fldIsInHouseProduction: false,
        fldItemsTotalValue: 0,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldRoundoff: 0
    },
    selectedTeam: {},
    detailsId: '',
    activeKey: 1,
    isCompactingDC: false,
    compactingDCSelectedValue: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let compactingDcDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_COMPACTING_DC_REQUEST_DK:
        case FETCH_COMPACTING_DC_STYLE_REQUEST_DK:
        case CREATE_COMPACTING_DC_REQUEST_DK:
        case FETCH_COMPACTING_DC_INVOICE_REQUEST:
        case FETCH_SINGLE_COMPACTING_DC_REQUEST_DK:
        case UPDATE_COMPACTING_DC_REQUEST_DK:
        case DELETE_COMPACTING_DC_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_COMPACTING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                compactingDC: updatePayload
            };
        case FETCH_COMPACTING_DC_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                compactingDCInvoice: updatePayload
            };
        case FETCH_COMPACTING_DC_STYLE_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                compactingDCStyleList: updatePayload?.PONO
            };

        case CREATE_COMPACTING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                detailsId: updatePayload
            };
        case FETCH_SINGLE_COMPACTING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedTeam: updatePayload,
                userform: updatePayload
            };
        case UPDATE_COMPACTING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
        case DELETE_COMPACTING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
        case FETCH_COMPACTING_DC_FAILURE_DK:
        case FETCH_COMPACTING_DC_STYLE_FAILURE_DK:
        case FETCH_SINGLE_COMPACTING_DC_FAILURE_DK:
        case CREATE_COMPACTING_DC_FAILURE_DK:
        case UPDATE_COMPACTING_DC_FAILURE_DK:
        case DELETE_COMPACTING_DC_FAILURE_DK:
        case FETCH_COMPACTING_DC_INVOICE_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_COMPACTING_DC_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case COMPACTING_DC_USERFORM_RESET_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                detailsId: '',
                activeKey: 1
            };
        case NAVIGATE_COMPACTING_DC_DETAILS_DK:
            return {
                ...state,
                isCompactingDC: true,
                compactingDCSelectedValue: updatePayload?.compactingDCSelectedValue
            };
        case NAVIGATE_COMPACTING_DC_DK:
            return {
                ...state,
                isCompactingDC: false
            };
        case RESET_COMPACTING_DC_INVOICE:
            return {
                ...state,
                compactingDCInvoice: []
            };
        case COMPACTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 2
            };
        case COMPACTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
